import { getUnifySelectAttrValue } from "../../utils/getUnifySelectData.js";
function getUnifySelectInventoryMaxQuantity(inventory) {
  let ret = getUnifySelectAttrValue(inventory, "maxLegacyNum");
  if (!ret) {
    ret = getUnifySelectAttrValue(inventory, "mostOrder");
  }
  return ret ? Number(ret) : void 0;
}
export { getUnifySelectInventoryMaxQuantity };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/business/unifySelectInventory/getUnifySelectInventoryMaxQuantity.js